import React, {useState} from 'react';
import { classNames } from '../../Services/helpers';
import TimeAgo from '../Formatting/TimeAgo';
import Icon from '../Icons/Icon';
import NoValue from '../EmptyStates/NoValue';
import NotificationLog from './NotificationLog';

const Message = ({message, isLast, nextIsSameDirection, fullWidth}) => {
    const [showTimestamp, setShowTimestamp] = useState(false);

    if (!message) {
        return <NoValue />;
    }

    if (message.journalId) {
        return <NotificationLog log={message} />
    }

    const { content, direction, sentAt, seenByContactAt } = message;

    return <div className={classNames(
            'rounded-xl py-2 px-3',
            nextIsSameDirection ? 'mb-1' : 'mb-3',
            fullWidth ? 'w-full' : 'max-w-[85%]',
            direction === 'Outbound' && 'place-self-end rounded-br-none bg-blue-100',
            direction === 'Inbound' && 'place-self-start rounded-bl-none bg-slate-100'
        )}
        onClick={() => setShowTimestamp(!showTimestamp)}
    >
        <p>{content}</p>
        {(isLast || showTimestamp) && <p className="text-xs text-muted">
            <TimeAgo dateTime={sentAt} />
            {(direction === 'Outbound' && seenByContactAt) && <span className="ml-2">
                <Icon icon="Check" size="0.5x" className="fill-brand" inline />
            </span>}
        </p>}
    </div>
}

export default Message;
